import * as Icons from '@mui/icons-material';

// Usage in JSX
const DynamicIcon = ({ iconName }) => {
  const Icon = Icons[iconName] || Icons['NotInterested']; // Fallback to NotInterested if icon not found
  return <Icon />;
};

export default DynamicIcon;
